<div class="settings">
    <select-extra-settings
        *ngIf="viewMode >= 2"
        [languages]="supportedLocales"
        [activeLanguage]="language"
        [componentOptions]="componentOptions"
        [selectText]="text"
        (optionsChanged)="onOptionsChanged($event)"
        (formStatusChanged)="onFormStatusChange($event)"
        [showOptions]="showOptions"
        (closeOptions)="onCloseOptions($event)"
    ></select-extra-settings>
</div>

<form [formGroup]="form">
    <table class="ham-table" *ngIf="viewMode >= 2">
        <thead>
            <tr>
                <th class="hamScaleCol" style="min-width: 400px">
                    <ham-referencing-input-component
                        class="referencing-input"
                        [isEditMode]="true"
                        [title]="componentOptions.title?.[language]"
                        [isReferenced]="addReferencing"
                        [isNumbered]="addNumbering"
                        [numbering]="tableNumber"
                        [width]="'400px'"
                        (titleChange)="onTitleChanged($event)"
                        (addNumbering)="onAddNumberToggleChange($event)"
                        (addReferencing)="openReferenceDialog()"
                    ></ham-referencing-input-component>
                </th>

                <th class="hamNumberCol300 highlight">
                    <span>{{ componentData.currentYearDate | dateLocale }}</span>
                </th>

                <th class="hamNumberCol300">
                    <span>{{ componentData.previousYearDate | dateLocale }}</span>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td class="hamScaleCol" style="min-width: 400px">
                    <input
                        hamInput
                        [formControl]="form.controls['text']"
                        type="text"
                        [placeholder]="'aumico_notes_select_option_description' | i18next"
                    />
                </td>
                <td
                    class="hamNumberCol300 highlight"
                    [ngClass]="{
                        todoHighlight:
                            highlightTodos &&
                            (form.controls['selectionForCurrentYearDate']?.value?.name === '' ||
                                form.controls['selectionForCurrentYearDate']?.value?.name === 0 ||
                                form.controls['selectionForCurrentYearDate']?.value?.name == null ||
                                form.controls['selectionForCurrentYearDate']?.value == null)
                    }"
                >
                    <input
                        hamSimpleDropDown
                        [formControl]="form.controls['selectionForCurrentYearDate']"
                        [placeholder]="text"
                        [options]="selectionOptions"
                        [optionKeys]="['name']"
                        returnKey="id"
                        [returnObject]="true"
                    />
                </td>
                <td
                    class="hamNumberCol300"
                    [ngClass]="{
                        todoHighlight:
                            highlightTodos &&
                            (form.controls['selectionForPreviousYearDate']?.value?.name === '' ||
                                form.controls['selectionForPreviousYearDate']?.value?.name === 0 ||
                                form.controls['selectionForPreviousYearDate']?.value?.name == null ||
                                form.controls['selectionForPreviousYearDate']?.value == null)
                    }"
                >
                    <input
                        hamSimpleDropDown
                        [formControl]="form.controls['selectionForPreviousYearDate']"
                        [placeholder]="text"
                        [options]="selectionOptions"
                        [optionKeys]="['name']"
                        returnKey="id"
                        [returnObject]="true"
                    />
                </td>
            </tr>
        </tbody>
    </table>
    <table class="ham-table" *ngIf="viewMode <= 1">
        <thead>
            <tr>
                <th class="hamScaleCol">
                    <ham-referencing-input-component
                        class="referencing-input"
                        [isEditMode]="false"
                        [title]="componentOptions.title?.[language]"
                        [isReferenced]="addReferencing"
                        [isNumbered]="addNumbering"
                        [numbering]="tableNumber"
                        (titleChange)="onTitleChanged($event)"
                        (addNumbering)="onAddNumberToggleChange($event)"
                        (addReferencing)="openReferenceDialog()"
                    ></ham-referencing-input-component>
                </th>

                <th class="hamNumberCol300 highlight">
                    <span>{{ componentData.currentYearDate | dateLocale }}</span>
                </th>

                <th class="hamNumberCol300">
                    <span>{{ componentData.previousYearDate | dateLocale }}</span>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td class="hamScaleCol">
                    <span>{{ text }}</span>
                </td>
                <td
                    class="hamNumberCol300 highlight"
                    [ngClass]="{
                        todoHighlight:
                            highlightTodos &&
                            (form.controls['selectionForCurrentYearDate']?.value?.name === '' ||
                                form.controls['selectionForCurrentYearDate']?.value?.name === 0 ||
                                form.controls['selectionForCurrentYearDate']?.value?.name == null ||
                                form.controls['selectionForCurrentYearDate']?.value == null)
                    }"
                >
                    <span>{{ form.controls['selectionForCurrentYearDate'].value?.name }}</span>
                </td>
                <td
                    class="hamNumberCol300"
                    [ngClass]="{
                        todoHighlight:
                            highlightTodos &&
                            (form.controls['selectionForPreviousYearDate']?.value?.name === '' ||
                                form.controls['selectionForPreviousYearDate']?.value?.name === 0 ||
                                form.controls['selectionForPreviousYearDate']?.value?.name == null ||
                                form.controls['selectionForPreviousYearDate']?.value == null)
                    }"
                >
                    <span>{{ form.controls['selectionForPreviousYearDate'].value?.name }}</span>
                </td>
            </tr>
        </tbody>
    </table>

    <!-- Footnote Section -->
    <div class="footnote-section" *ngIf="hasFootnotes">
        <label for="footnote">{{ 'aumico_notes_footnote_label' | i18next }}</label>
        <textarea
            hamInput
            [hideRemoveXButton]="true"
            [formControl]="form.controls['footnote']"
            [placeholder]="'aumico_notes_footnote_placeholder' | i18next"
        ></textarea>
    </div>
</form>
